import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';

import UserSelectedChip from '../UserSelectedChip/UserSelectedChip';
import * as keyCodes from '../../../../../../../utils/keyCodes';
import {
  ParentContainer,
  Container,
  Input,
  className,
  CancelButton,
} from './UserSearch.styled';
import { CancelIcon } from '../UserSelectedChip/UserSelectedChip.styled';
import { User } from '../types';

const UserSearch = React.forwardRef(
  (
    {
      title,
      onSearchQueryChanged,
      searchQuery,
      selectedUsers,
      setSelectedUsers,
      onTextReset,
    },
    ref
  ) => {
    useEffect(() => {
      ref.current.focus();
    }, []);
    const [inputFocus, setInputFocus] = useState(false);
    const removeUserFromSelectedUser = (userIndex) => {
      const updatedSelectedItem = [...selectedUsers];
      updatedSelectedItem.splice(userIndex, 1);
      setSelectedUsers(updatedSelectedItem);
      ref.current.focus();
    };
    const onRemoveUser = (userIndex) => () => {
      removeUserFromSelectedUser(userIndex);
    };

    const onKeyDown = (event) => {
      if (event.target.value !== '') {
        return;
      }
      if (event.keyCode === keyCodes.BACKSPACE) {
        const newItems = selectedUsers.slice(0, selectedUsers.length - 1);
        setSelectedUsers(newItems);
      }
    };

    const onChange = (event) => {
      onSearchQueryChanged(event.target.value);
      ref.current.focus();
    };

    const hasSelection = searchQuery !== '' || selectedUsers.length > 0;
    return (
      <ParentContainer className={inputFocus ? className.inputFocus : ''}>
        <Container>
          {selectedUsers.length ? (
            selectedUsers.map((user, userIndex) => (
              <UserSelectedChip
                data-testid="user-selected-chip"
                key={user.id}
                onRemoveChip={onRemoveUser(userIndex)}
                user={user}
                onKeyDown={(event) => {
                  if (
                    event.keyCode === keyCodes.BACKSPACE ||
                    event.keyCode === keyCodes.DELETE
                  ) {
                    removeUserFromSelectedUser(userIndex);
                  }
                }}
              />
            ))
          ) : (
            <SearchIcon fontSize="small" className="searchIcon" />
          )}
          <Input
            inputRef={ref}
            placeholder={selectedUsers.length === 0 ? title : ''}
            inputProps={{
              'aria-label': title,
            }}
            disableUnderline
            value={searchQuery}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onFocus={() => {
              setInputFocus(true);
            }}
            onBlur={() => (!hasSelection ? setInputFocus(false) : null)}
          />
        </Container>
        {searchQuery !== '' ? (
          <CancelButton
            label="Reset selection"
            onClick={() => {
              onTextReset();
              onSearchQueryChanged('');
              ref.current.focus();
            }}
            size="medium"
            icon={CancelIcon}
          />
        ) : null}
      </ParentContainer>
    );
  }
);

UserSearch.propTypes = {
  title: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
  onSearchQueryChanged: PropTypes.func.isRequired,
  setSelectedUsers: PropTypes.func.isRequired,
  selectedUsers: PropTypes.arrayOf(User),
  onTextReset: PropTypes.func.isRequired,
};

UserSearch.defaultProps = {
  selectedUsers: [],
};

export default UserSearch;
